import { instance } from "./axios";

export const updateRawMaterialChamber = (payload, id) => {
  try {
    return instance.put(`/visit/rawMaterial/${id}`, payload);
  } catch (error) {
    throw error;
  }
};